Promise.all([import('../../plugins/semantic/form'), import('../../plugins/semantic/form.scss')]).then(() => {
  Promise.all([
    import('./accommodation-enquiry-form.scss'),
    import('../../scripts/dbs/dbs.semantic.form'),
    import('../../scripts/dbs/dbs.utilities.querystring'),
    import('../../plugins/semantic/tab.css'),
    import('../../plugins/semantic/label.css'),
    import('../../plugins/semantic/tab'),
    import('../../plugins/semantic/dropdown'),
    import('../../plugins/semantic/dropdown.scss'),
    import('../../plugins/semantic/icon.css'),
    import('../../plugins/semantic/flag.css'),
    import('../../plugins/semantic/transition.css'),
    import('../../plugins/semantic/transition'),
    import('../../plugins/semantic/api'),
    import('../../plugins/semantic/checkbox.css'),
    import('../../plugins/semantic/checkbox'),
  ]).then(() => {
    $('.widget.accommodation-enquiry-form').each(function (i, el) {
      $(el).data('widget', new AccommodationEnquiryForm(el))
      $(el).data('widget').init()
    })
  })
})

function AccommodationEnquiryForm(el) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AccommodationEnquiryForm init', self)
    }

    self.el.css('opacity', 1)
  }
}
